import React, { useState } from "react";
import { Link } from "react-router-dom";
import Card from "components/card";
import api from "api";

const BusinessFormView = () => {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    category: "",
    phone: "",
    email: "",
    website: "",
    address: "",
  });

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage("");
    setError("");
    try {
      const response = await api.post("/user/business", formData);
      setMessage("Business listing created successfully!");
      setFormData({ // Clear form after successful submission
        name: "",
        description: "",
        category: "",
        phone: "",
        email: "",
        website: "",
        address: "",
      });
      console.log(response.data);
    } catch (err: any) {
      setError(err.response?.data?.message || "Failed to create business listing.");
      console.error(err);
    }
  };

  return (
    <div className="flex w-full flex-col gap-5 lg:gap-5">
      <div className="w-ful mt-3 flex h-fit flex-col gap-5 lg:grid lg:grid-cols-12">
        <div className="col-span-12 lg:col-span-12 lg:mb-0">
          <Card extra="w-full h-full p-4">
            <div className="mb-8 mt-4 flex items-center justify-between">
              <h4 className="text-xl font-bold text-navy-700 dark:text-white">
                Create New Business Listing
              </h4>
            </div>

            {message && <div className="mb-4 text-green-500">{message}</div>}
            {error && <div className="mb-4 text-red-500">{error}</div>}

            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label
                  htmlFor="name"
                  className="text-sm text-navy-700 dark:text-white"
                >
                  Business Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="mt-2 flex h-12 w-full items-center justify-center rounded-xl border border-gray-200 bg-white/0 p-3 text-sm outline-none dark:!border-white/10 dark:text-white"
                  required
                />
              </div>

              <div className="mb-4">
                <label
                  htmlFor="description"
                  className="text-sm text-navy-700 dark:text-white"
                >
                  Description
                </label>
                <textarea
                  id="description"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  className="mt-2 flex h-24 w-full items-center justify-center rounded-xl border border-gray-200 bg-white/0 p-3 text-sm outline-none dark:!border-white/10 dark:text-white"
                  required
                ></textarea>
              </div>

              <div className="mb-4">
                <label
                  htmlFor="category"
                  className="text-sm text-navy-700 dark:text-white"
                >
                  Category
                </label>
                <input
                  type="text"
                  id="category"
                  name="category"
                  value={formData.category}
                  onChange={handleChange}
                  className="mt-2 flex h-12 w-full items-center justify-center rounded-xl border border-gray-200 bg-white/0 p-3 text-sm outline-none dark:!border-white/10 dark:text-white"
                  required
                />
              </div>

              <div className="mb-4">
                <label
                  htmlFor="phone"
                  className="text-sm text-navy-700 dark:text-white"
                >
                  Phone (Optional)
                </label>
                <input
                  type="text"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="mt-2 flex h-12 w-full items-center justify-center rounded-xl border border-gray-200 bg-white/0 p-3 text-sm outline-none dark:!border-white/10 dark:text-white"
                />
              </div>

              <div className="mb-4">
                <label
                  htmlFor="email"
                  className="text-sm text-navy-700 dark:text-white"
                >
                  Email (Optional)
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="mt-2 flex h-12 w-full items-center justify-center rounded-xl border border-gray-200 bg-white/0 p-3 text-sm outline-none dark:!border-white/10 dark:text-white"
                />
              </div>

              <div className="mb-4">
                <label
                  htmlFor="website"
                  className="text-sm text-navy-700 dark:text-white"
                >
                  Website (Optional)
                </label>
                <input
                  type="url"
                  id="website"
                  name="website"
                  value={formData.website}
                  onChange={handleChange}
                  className="mt-2 flex h-12 w-full items-center justify-center rounded-xl border border-gray-200 bg-white/0 p-3 text-sm outline-none dark:!border-white/10 dark:text-white"
                />
              </div>

              <div className="mb-4">
                <label
                  htmlFor="address"
                  className="text-sm text-navy-700 dark:text-white"
                >
                  Address (Optional)
                </label>
                <input
                  type="text"
                  id="address"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  className="mt-2 flex h-12 w-full items-center justify-center rounded-xl border border-gray-200 bg-white/0 p-3 text-sm outline-none dark:!border-white/10 dark:text-white"
                />
              </div>

              <button
                type="submit"
                className="linear rounded-xl bg-brand-500 px-4 py-2 text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90"
              >
                Create Listing
              </button>
              <Link
                to="/user/businesses"
                className="ml-4 linear rounded-xl border border-gray-200 px-4 py-2 text-base font-medium text-navy-700 transition duration-200 hover:bg-gray-100 dark:border-white/10 dark:text-white dark:hover:bg-white/5"
              >
                Cancel
              </Link>
            </form>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default BusinessFormView;
